import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	deleteButton: {
		width: theme.spacing(4),
		height: theme.spacing(4),
		borderRadius: 3,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		color: colors.red[500]
	}
}))

export default useStyles
